// extracted by mini-css-extract-plugin
export var link = "_su-0";